<template>
  <w-event-common-table eventType="status" ref="eventCommonTableRef" :active="active"></w-event-common-table>
</template>

<script>
import WEventCommonTable from '@/views/event/components/EventCommonTable';

export default {
  name: 'WEventStatus',
  components: { WEventCommonTable },
  props: {
    active: Boolean,
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.$store.dispatch('setSelectedEvents', []);
        }
      },
    },
  },
  methods: {
    loadData() {
      this.$refs.eventCommonTableRef.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-status/index.vue